import styled from "styled-components";
import { DIGIPOSTHEME } from "theme/digiPosTheme";

type StyledAlertProps = {
  alertType: "Success" | "Error";
  isVisible: boolean;
};

export const StyledAlert = styled.div<StyledAlertProps>`
  margin: 10px 0;
  border-radius: 5px;
  font-weight: bold;
  width: 100%;
  background-color: ${({ alertType = "Success" }) =>
    alertType === "Success"
      ? DIGIPOSTHEME.colors.primaryToggleGreen
      : DIGIPOSTHEME.colors.headerRed};
  padding: 15px;
  color: ${DIGIPOSTHEME.colors.secondaryAkbankWhite};
  display: ${({ isVisible = false }) => (isVisible ? "block" : "none")};
`;

export const StyledAlertSuccessText = styled.div`
  font-weight: bold;
  color: ${DIGIPOSTHEME.colors.secondaryAkbankWhite};
`;
